import { HomeRecentlyClosedDeals } from './HomeRecentlyClosedDeals';

export default HomeRecentlyClosedDeals;
